import { useStores } from 'app/store'
import { useCallback } from 'react'

export function useLogout() {
  const { userStore } = useStores()

  return useCallback(() => {
    userStore.logout()
    window.location.href = '/api/auth/logout'
  }, [userStore])
}
